import { createCommentVNode as _createCommentVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50d41b92"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "box_sso",
  class: "box_sso"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "box_table" }
const _hoisted_4 = { class: "cell" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "我已阅读并同意", -1 /* HOISTED */))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "和", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_MobileOutlined = _resolveComponent("MobileOutlined")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_SafetyCertificateOutlined = _resolveComponent("SafetyCertificateOutlined")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_WechatOutlined = _resolveComponent("WechatOutlined")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createCommentVNode("<SSOBackground v-if=\"!$Store.User().isHideMsg\" />"),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          ($data.expand.isShow)
            ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
                default: _withCtx(() => [
                  _createCommentVNode("<a-col :xs=\"24\" :lg=\"!$Store.User().isHideMsg?12:24\" style=\"display: flex;align-items: center;justify-content: center;\">"),
                  _createVNode(_component_a_col, {
                    xs: 24,
                    style: {"display":"flex","align-items":"center","justify-content":"center"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form, {
                        ref: "form",
                        model: $data.form.data,
                        rules: $data.form.rule
                      }, {
                        default: _withCtx(() => [
                          _createCommentVNode("<i class=\"logo\" v-if=\"!$Store.User().isHideMsg\" />"),
                          _createCommentVNode("<a-typography-title :level=\"1\">"),
                          _createCommentVNode("    登录/注册"),
                          _createCommentVNode("</a-typography-title>"),
                          _createVNode(_component_a_typography_title, { level: 2 }, {
                            default: _withCtx(() => [
                              (!$data.form.data.wechat_uid)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createCommentVNode("现在注册应用市场"),
                                    _createCommentVNode("<template v-if=\"$Store.Public().isGridMatch('>=',$Enum.GridEnum.LG)\">，</template>"),
                                    _createCommentVNode("<br v-else />即刻免费体验30分钟AI应用"),
                                    _createCommentVNode("在校师生福利！<br v-if=\"$Store.Public().isGridMatch('<',$Enum.GridEnum.LG)\" />充值100元赠送2000消耗点！多充多送！"),
                                    _createCommentVNode("注册即送100消费点"),
                                    _createCommentVNode("<template v-if=\"$Store.Public().isGridMatch('>=',$Enum.GridEnum.LG)\">，</template>"),
                                    _createCommentVNode("<br v-else />"),
                                    _createCommentVNode("欢迎注册体验～")
                                  ], 64 /* STABLE_FRAGMENT */))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(" 微信注册成功 "),
                                    (_ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.LG))
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createTextVNode("，")
                                        ], 64 /* STABLE_FRAGMENT */))
                                      : (_openBlock(), _createElementBlock("br", _hoisted_5)),
                                    _createTextVNode("请先绑定手机号 ")
                                  ], 64 /* STABLE_FRAGMENT */))
                            ]),
                            _: 1 /* STABLE */
                          }),
                          _createVNode(_component_a_form_item, {
                            name: "phone",
                            "has-feedback": ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                value: $data.form.data.phone,
                                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (($data.form.data.phone) = $event)),
                                placeholder: "手机号",
                                maxlength: _ctx.$Check.Constraint.Phone,
                                "show-count": $data.form.data.phone.length>0,
                                "allow-clear": ""
                              }, {
                                prefix: _withCtx(() => [
                                  _createVNode(_component_MobileOutlined, { class: "input_icon" })
                                ]),
                                _: 1 /* STABLE */
                              }, 8 /* PROPS */, ["value", "maxlength", "show-count"])
                            ]),
                            _: 1 /* STABLE */
                          }),
                          _createVNode(_component_a_row, { class: "box_auth" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, { span: 13 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, {
                                    name: "code",
                                    "has-feedback": ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_input, {
                                        value: $data.form.data.code,
                                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (($data.form.data.code) = $event)),
                                        placeholder: "验证码",
                                        maxlength: _ctx.$Check.Constraint.AuthX,
                                        "show-count": $data.form.data.code.length>0,
                                        "allow-clear": ""
                                      }, {
                                        prefix: _withCtx(() => [
                                          _createVNode(_component_SafetyCertificateOutlined, { class: "input_icon" })
                                        ]),
                                        _: 1 /* STABLE */
                                      }, 8 /* PROPS */, ["value", "maxlength", "show-count"])
                                    ]),
                                    _: 1 /* STABLE */
                                  })
                                ]),
                                _: 1 /* STABLE */
                              }),
                              _createVNode(_component_a_col, {
                                offset: 1,
                                span: 10
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_button, {
                                    type: "primary",
                                    loading: $data.request.intercept.auth,
                                    disabled: $data.setTime.countdown,
                                    onClick: $options.getAuthCode,
                                    block: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString($data.expand.countdown.text), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                  }, 8 /* PROPS */, ["loading", "disabled", "onClick"])
                                ]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _: 1 /* STABLE */
                          }),
                          _createVNode(_component_a_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, {
                                class: "box_protocol",
                                span: 24
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_checkbox, {
                                        checked: $data.expand.protocol,
                                        "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => (($data.expand.protocol) = $event)),
                                        color: "geekblue"
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_6,
                                          _createVNode(_component_a_button, {
                                            type: "link",
                                            target: "_blank",
                                            href: _ctx.$Config.Protocol.user
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" 用户注册协议 ")
                                            ]),
                                            _: 1 /* STABLE */
                                          }, 8 /* PROPS */, ["href"]),
                                          _hoisted_7,
                                          _createVNode(_component_a_button, {
                                            type: "link",
                                            target: "_blank",
                                            href: _ctx.$Config.Protocol.privacy
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" 隐私政策协议 ")
                                            ]),
                                            _: 1 /* STABLE */
                                          }, 8 /* PROPS */, ["href"]),
                                          _createCommentVNode(" <span style=\"margin:0 -2px\">和</span>\n                        <a-button type=\"link\" target=\"_blank\"\n                                  :href=\"$Config.Protocol.disclaimers\">\n                          免责声明\n                        </a-button> ")
                                        ]),
                                        _: 1 /* STABLE */
                                      }, 8 /* PROPS */, ["checked"])
                                    ]),
                                    _: 1 /* STABLE */
                                  })
                                ]),
                                _: 1 /* STABLE */
                              }),
                              _createVNode(_component_a_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_button, {
                                    type: "primary",
                                    onClick: $options.submit,
                                    block: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(!$data.form.data.wechat_uid ? '登录/注册' : '绑定手机号'), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                  }, 8 /* PROPS */, ["onClick"])
                                ]),
                                _: 1 /* STABLE */
                              }),
                              _createVNode(_component_a_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_button, {
                                    class: "button_return",
                                    onClick: $options.returnFromLogin,
                                    block: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" 返回 ")
                                    ]),
                                    _: 1 /* STABLE */
                                  }, 8 /* PROPS */, ["onClick"])
                                ]),
                                _: 1 /* STABLE */
                              }),
                              ($options.isShowWeChat)
                                ? (_openBlock(), _createBlock(_component_a_col, {
                                    key: 0,
                                    span: 24
                                  }, {
                                    default: _withCtx(() => [
                                      (!_ctx.$Store.User().isHideMsg)
                                        ? (_openBlock(), _createBlock(_component_a_button, {
                                            key: 0,
                                            type: "link",
                                            class: "button_register",
                                            onClick: $options.weChatLogin,
                                            block: ""
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_WechatOutlined),
                                              _createTextVNode(" 微信登录 ")
                                            ]),
                                            _: 1 /* STABLE */
                                          }, 8 /* PROPS */, ["onClick"]))
                                        : _createCommentVNode("v-if", true)
                                    ]),
                                    _: 1 /* STABLE */
                                  }))
                                : _createCommentVNode("v-if", true)
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["model", "rules"])
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createCommentVNode("<a-col v-if=\"$Store.Public().isGridMatch('>=',$Enum.GridEnum.LG)&&!$Store.User().isHideMsg\""),
                  _createCommentVNode("       :xs=\"24\" :lg=\"12\">"),
                  _createCommentVNode("  <SSOIntroduce />"),
                  _createCommentVNode("</a-col>")
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ])
  ]))
}